module.exports = "/build/web/svg/chevron-left-white.a02dfde716e349c04ad4c4b93e8057f3.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/chevron-left-white.svg
// module id = 91
// module chunks = 24